import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Custom hook to extract query parameters from URL
 * Uses React Router's useSearchParams for better performance and reactivity
 * 
 * @returns Object containing merchantId, employeeId, clientId, and code
 * 
 * @example
 * const { merchantId, code } = useQueryParams();
 * if (merchantId && code) {
 *   // Process OAuth callback
 * }
 */
export const useQueryParams = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => ({
    merchantId: searchParams.get('merchant_id'),
    employeeId: searchParams.get('employee_id'),
    clientId: searchParams.get('client_id'),
    code: searchParams.get('code'),
  }), [searchParams]);
};
